import { onUnmounted } from 'vue';
import { debounce } from 'radash';
export const useWindowResize = (cb: () => void, delay: number = 100) => {
    let currentScreenWidth = window.document.documentElement.clientWidth;
    const onWindowResize = debounce({ delay, }, () => {
        if (window.document.documentElement.clientWidth !== currentScreenWidth) {
            currentScreenWidth = window.document.documentElement.clientWidth;
            cb();
        }
    });
    window.addEventListener('resize', onWindowResize);
    onUnmounted(() => {
        window.removeEventListener('resize', onWindowResize);
    });
};
